

export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setSellers(state, sellers) {
    state.sellers = sellers;
}

export function setContacts(state, contacts) {
    state.contacts = contacts;
}
export function setreporte_bo(state, reporte_bo) {
    state.reporte_bo = reporte_bo
    //console.log(reporte_comisiones);
}
export function setParams(state, params){
    state.params = params
}
export function setStatesAuth(state, data){
    state.stateAuthOption = data
    let defaults = [];
    state.stateAuthOption.forEach(el => {
        if ([ '03', '05' ].includes(el.code_parameter)){
            defaults.push(el.id)
        }
    });

    state.params.state_auth = defaults;
}
export function setUnds(state, unds) {
    console.log(state.reporte_bo)

    state.reporte_bo.data.map(doc => {
        let und = unds.find(el => el.document_id == doc.document_id)
        if (und) {
            // setTimeout(() => {
            doc.total_backorder_quantity = und.total_backorder_quantity
            doc.total_unds = und.total_unds
            doc.loading_unds = false
            // }, 150);
        }
    })
}



// WEBPACK FOOTER //
// ./src/modules/report-bo/mutations.js